import Button from "../../../../../components/Buttons/Button";
import Dropdown from "../../../../../components/Inputs/Selects/CustomSelect";
import MultiSelectCheck, { ISelectedItem } from "../../../../../components/Inputs/Selects/MultiSelectCheck";
import { Filtro } from "../../../../../interfaces/Indicator";

export interface IFilterInputs {
    variables: Filtro[];
    typeOfGraph: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | number;
    handleSelectVariable: (label: string, value?: string) => void;
    selectedVariables: {
        [key: string]: string[];
    };
    handleSelectMultipleVariables: ({ value, label }: ISelectedItem) => void;
    areFiltersModified: () => boolean;
    handleCleanFilters: () => void;
}

const FilterInputs = ({
    variables,
    typeOfGraph,
    handleSelectVariable,
    selectedVariables,
    handleSelectMultipleVariables,
    areFiltersModified,
    handleCleanFilters
}: IFilterInputs) => {
    return (
        <div className="flex flex-row flex-wrap gap-3 items-end">
            {variables && variables?.length > 0
                ? variables?.map((variable) => {
                    return typeOfGraph === 6 || typeOfGraph === 7 ? (
                        <Dropdown
                            key={variable.name}
                            options={variable.values}
                            onSelect={handleSelectVariable}
                            selectedItem={selectedVariables?.[variable?.name]?.[0] ?? ''}
                            defaultSelectedItem={selectedVariables?.[variable?.name]?.[0] || "Seleccione"}
                            label={variable.name}
                            className="w-full md:!max-w-[200px] md:w-[200px] !bg-transparent"
                            variant="outline-dark"
                        />
                    ) : (
                        <MultiSelectCheck
                            key={variable.name}
                            options={variable.values}
                            onSelect={handleSelectMultipleVariables}
                            selectedItems={
                                (selectedVariables[variable.name] || []).map(value => ({
                                    value,
                                    label: variable.name,
                                }))
                            }
                            label={variable.name}
                            className="w-full md:!max-w-[200px] md:w-[200px] !bg-transparent"
                            variant="outline-dark"
                        />
                    );
                })
                : null}
            {variables.length > 0 && areFiltersModified() && (
                <Button
                    label='Limpiar filtros'
                    type='button'
                    showIconLeft={false}
                    showIconRight={false}
                    className='text-primary-40 !px-2'
                    variant="none"
                    onClick={handleCleanFilters}
                />
            )}
        </div>
    )
}

export default FilterInputs